<template>
  <div class="about">
    <h1>About TeamStack</h1>
    <p>TeamStack is a powerful platform designed to help teams collaborate and manage their projects efficiently.</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.about {
  padding: 20px;
}

h1 {
  color: #42b983;
  margin-bottom: 20px;
}
</style> 